import { z } from 'zod/v3';

/**
 * Checks if a Zod object schema has zero required properties
 * @param schema The Zod schema to check
 * @returns boolean indicating if the object has only optional properties
 */
export function isEmptyZodObject(schema: z.ZodTypeAny): boolean {
  // Check if it's an object schema
  if (!(schema instanceof z.ZodObject)) {
    return false;
  }

  // Access the shape property which contains the object properties
  const zodObject = schema as z.ZodObject<any>;

  // Get the shape which is a record of properties
  const shape = zodObject._def.shape();

  // Check each property to see if any are required
  for (const key in shape) {
    const field = shape[key];
    // If the field is not optional (not wrapped in .optional())
    if (!(field instanceof z.ZodOptional)) {
      return false;
    }
  }

  return true;
}
